/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, FormGroup, Row } from "react-bootstrap";
import { Brand, OptionsProps } from "./dataForms";
import { Fetch, IFetchProps } from "../../services/Fetch";
import { endpoints } from "../../data/endpoints";
import { useSelector } from "react-redux";

type fields =
  | "areaFilters"
  | "coreFilters"
  | "modalityFilters"
  | "levelCourseFilters"
  | "departamentFilters"
  | "municipalityFilters"
  | "programFilters"
  | "btnSubmit"
  | "btnCancel";

interface FilterSelectsProps {
  children?: any;
  titleCard?: string;
  btnLabel?: string;
  onSubmit: (value?: any) => void;
  onCancel?: () => void;
  omit?: fields[];
  filters?: any;
}

const FilterSelects = ({
  children,
  titleCard,
  btnLabel,
  onSubmit,
  onCancel,
  omit = [],
  filters,
}: FilterSelectsProps) => {
  const { token } = useSelector((state: any) => state.auth.user);
  const [data, setData] = useState<any>();
  const [filterSelects, setFilterSelects] = useState<any>({});

  const setFilters = (response: any) => {
    const { programa, msg, statusCode, ...res } = response;
    const program: OptionsProps[] = [];

    programa.forEach((pro: any) => {
      program.push({
        label: pro.code_snies_program + " - " + pro.program_name,
        value: pro.uid,
      });
    });
    const keys = Object.keys(res);
    let sel = { programs: program };
    keys.forEach((key: any) => {
      const options: OptionsProps[] = [];
      res[key].forEach((k: any) => {
        options.push({
          label: k,
          value: k,
        });
      });
      sel = { ...sel, [key]: options };
    });
    setData({ ...sel });
  };

  // funcion para consultar todos los programas y algunas de sus carateristicas para eleccion en los filtros
  const getFilters = async () => {
    const queryParams = Object.entries(filterSelects)
      .map(([key, value]: any) => `${key}=${value}`)
      .join("&");

    const propsFetch: IFetchProps = {
      Endpoint: `${endpoints.programs.filters}?${queryParams}`,
      method: "GET",
      token,
    };
    const response: any = await Fetch(propsFetch);
    if (response.statusCode && response.statusCode === 200) {
      setFilters(response);
    }
  };

  const handleSelectChange = (opt: any) => {
    setFilterSelects({ ...filterSelects, [opt.Name]: opt.value });
  };

  const handleSubmit = () => {
    onSubmit(filterSelects);
  };

  const handleCancel = () => {
    setFilterSelects({});
    onCancel && onCancel();
  };

  useEffect(() => {
    getFilters();
  }, [filterSelects]);

  useEffect(() => {
    if (filters) {
      setFilterSelects(filters);
    }
  }, [filters]);

  return (
    <Card>
      <Card.Header>
        <h3 className="card-title">
          {titleCard ?? "CRITERIOS DE CONSULTA POR PROGRAMAS"}
        </h3>
      </Card.Header>
      <Card.Body>
        <div>
          <Row>
            {!omit.includes("areaFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Area de Conocimiento
                  </Form.Label>
                  <Brand
                    Options={data?.areaC ?? []}
                    Placeholder="Seleccionar Area de Conocimiento"
                    Name="areaFilters"
                    Onchange={handleSelectChange}
                    defaultValue={filterSelects.areaFilters}
                  />
                </FormGroup>
              </Col>
            )}
            {!omit.includes("coreFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Nucleo Basico de Conocimineto
                  </Form.Label>
                  <Brand
                    Options={data?.nucleoBC ?? []}
                    Placeholder="Seleccionar Nucleo Basico de Conocimineto"
                    Name="coreFilters"
                    Onchange={handleSelectChange}
                    defaultValue={filterSelects.coreFilters}
                  />
                </FormGroup>
              </Col>
            )}
            {!omit.includes("modalityFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Metodologia del programa
                  </Form.Label>
                  <Brand
                    Options={data?.Modalidad ?? []}
                    Placeholder="Seleccionar Metodologia del programa"
                    Name="modalityFilters"
                    Onchange={handleSelectChange}
                    defaultValue={filterSelects.modalityFilters}
                  />
                </FormGroup>
              </Col>
            )}
            {!omit.includes("levelCourseFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Nivel de Formacion
                  </Form.Label>
                  <Brand
                    Options={data?.nivelFormacion ?? []}
                    Placeholder="Seleccionar Nivel de Formacion"
                    Name="levelCourseFilters"
                    Onchange={handleSelectChange}
                    defaultValue={filterSelects.levelCourseFilters}
                  />
                </FormGroup>
              </Col>
            )}
            {!omit.includes("departamentFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Departamento
                  </Form.Label>
                  <Brand
                    Options={data?.departamentoOP ?? []}
                    Placeholder="Seleccionar Departamento"
                    Name="departamentFilters"
                    Onchange={handleSelectChange}
                    defaultValue={filterSelects.departamentFilters}
                  />
                </FormGroup>
              </Col>
            )}
            {!omit.includes("municipalityFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Municipio
                  </Form.Label>
                  <Brand
                    Options={data?.municipioOP ?? []}
                    Placeholder="Seleccionar Municipio"
                    Name="municipalityFilters"
                    Onchange={handleSelectChange}
                    defaultValue={filterSelects.municipalityFilters}
                  />
                </FormGroup>
              </Col>
            )}
            {!omit.includes("programFilters") && (
              <Col sm={12} md={12} lg={12} xl={12}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Programa académico
                  </Form.Label>
                  <Brand
                    Options={data?.programs ?? []}
                    Placeholder="Seleccionar Programa académico"
                    Name="programFilters"
                    Onchange={handleSelectChange}
                    defaultValue={data?.programs.find(
                      (item: any) => item.value === filterSelects.programFilters
                    )}
                  />
                </FormGroup>
              </Col>
            )}
            {/* <Col sm={12} md={12} lg={12} xl={12}>
              <FormGroup className="form-group">
                <Form.Label className="form-label text-dark">Pensum</Form.Label>
                <Brand
                  Options={data?.programs ?? []}
                  Placeholder="Seleccionar pensum"
                  Name="pensum"
                  // Onchange={handleSelectChange}
                />
              </FormGroup>
            </Col> */}
            {children}
            <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
              <Row>
                {!omit.includes("btnSubmit") && (
                  <Col style={{ textAlign: "center" }}>
                    <Button
                      className="btn btn-primary w-100"
                      onClick={handleSubmit}
                    >
                      {btnLabel ?? "Consultar"}
                    </Button>
                  </Col>
                )}
                {!omit.includes("btnCancel") && (
                  <Col style={{ textAlign: "center" }}>
                    <Button
                      className="btn btn-secondary w-100"
                      onClick={handleCancel}
                    >
                      Cancelar
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

export default FilterSelects;
